<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
  </section>
</div>
